import React from 'react';
import PropTypes from 'prop-types';
import styles from '../icon.scss';

const HelpIcon = ({ 'aria-hidden': ariaHidden, ...rest }) => (
  <svg
    {...rest}
    className={styles.icon}
    width={32}
    height={32}
    focusable="false"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-icontype="Help"
    data-testid="Portal-Help-Icon"
    aria-hidden={ariaHidden}
  >
    <circle cx="16" cy="16.001" r="16" fill="#E3F8EF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4796 12.7476C13.6476 11.7398 14.5196 11.001 15.5414 11.001H16.9325C17.6278 11.001 18.2115 11.5247 18.2868 12.2159C18.35 12.7959 18.0367 13.3518 17.5078 13.5983L17.2206 13.7321C15.561 14.5053 14.5 16.1702 14.5 18.001C14.5 18.8295 15.1716 19.501 16 19.501C16.8284 19.501 17.5 18.8295 17.5 18.001C17.5 17.3364 17.8851 16.7321 18.4876 16.4514L18.7748 16.3176C20.4684 15.5285 21.4715 13.7485 21.2692 11.8911C21.0281 9.6777 19.1589 8.00104 16.9325 8.00104H15.5414C13.0531 8.00104 10.9295 9.79999 10.5204 12.2544C10.3842 13.0716 10.9362 13.8444 11.7534 13.9806C12.5705 14.1168 13.3434 13.5648 13.4796 12.7476ZM16 24.5263C16.9734 24.5263 17.7626 23.7372 17.7626 22.7637C17.7626 21.7902 16.9734 21.001 16 21.001C15.0265 21.001 14.2373 21.7902 14.2373 22.7637C14.2373 23.7372 15.0265 24.5263 16 24.5263Z"
      fill="#00786A"
    />
  </svg>
);
HelpIcon.displayName = 'HelpIcon';
HelpIcon.propTypes = {
  'aria-hidden': PropTypes.bool,
};
export default HelpIcon;
